// Cards da tela de Logística Reversa: quando a Reversa Consolidada aparece (cliente habilitado e
// remetente de uma UF com caixa postal), só ela é exibida; as reversas dos Correios ficam de fora.
// A regra vale mesmo se a cotação da consolidada falhar (o card dela aparece como indisponível).
export function reverseCardsToShow(cards) {
  const list = Array.isArray(cards) ? cards : [];
  return list.some((card) => card && card.consolidated) ? list.filter((card) => card && card.consolidated) : list;
}

// Aviso acima dos cards: só quando a lista exibida é da Reversa Consolidada.
export function isConsolidatedOnly(cards) {
  return Array.isArray(cards) && cards.length > 0 && cards.every((card) => card && card.consolidated);
}
